import React from "react";
import "./Pages.css";
export default function Arcade() {
  return (
    <section className="titulo">
      <h2>Arcade</h2>
      <div className="subtitulo">
        <p>Conheça nossas Máquinas e Brinquedos!</p>
      </div>
      <div className="img-container">
        <img loading="lazy" src="/images-webp/Arcade/arcade.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade1.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade31.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade2.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade3.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade4.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade30.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade16.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade15.1.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade14.1.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade13.1.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade22.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade23.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade34.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade35.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade29.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade36.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade37.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade38.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade7.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade8.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade9.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade10.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade11.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade12.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade17.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade18.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade24.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade19.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade20.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade21.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade25.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade26.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade28.webp" alt="arcade" />
        <img loading="lazy" src="/images-webp/Arcade/arcade27.webp" alt="arcade" />
      </div>
    </section>
  );
}
